import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';

export const IcsConversationLoadDetailsActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[ics/conversation] Load details'),
  requestFail: uniqueActionType('[ics/conversation] Load details fail'),
  requestSuccess: uniqueActionType('[ics/conversation] Load details success'),
  requestClearErrors: uniqueActionType('[ics/conversation] Load details clear errors'),
  requestClear: uniqueActionType('[ics/conversation] Load details clear')
};

export class IcsConversationLoadDetailsAction implements PayloadAction {
  readonly type = IcsConversationLoadDetailsActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class IcsConversationLoadDetailsFailAction implements PayloadAction {
  readonly type = IcsConversationLoadDetailsActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class IcsConversationLoadDetailsSuccessAction implements PayloadAction {
  readonly type = IcsConversationLoadDetailsActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class IcsConversationLoadDetailsClearAction implements PayloadAction {
  readonly type = IcsConversationLoadDetailsActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}

export class IcsConversationLoadDetailsClearErrorsAction implements PayloadAction {
  readonly type = IcsConversationLoadDetailsActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}
